import { render, staticRenderFns } from "./FullContent.vue?vue&type=template&id=f8ea4b5e&scoped=true&"
var script = {}
import style0 from "./FullContent.vue?vue&type=style&index=0&id=f8ea4b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ea4b5e",
  null
  
)

export default component.exports